export class Proforma {
  idProforma : string ="";
  idProspecto : string ="";
  Observaciones: string = '';
  Fecha : Date = new Date() ;
  Tipo_Comprobante :string ="" ;
  Fecha_Desembolso :Date = new Date() ;
  Fecha_Proforma :Date = new Date() ;
  Moneda : number ;
  Moneda_Dsc : string ;
  TEM :number ;
  Adelanto_porcentaje :number;
  Adelanto_Importe :number ;
  Interes_Importe :number ;
  Comision_Importe :number ;
  IGV_Importe :number ;
  Desembolso_Importe :number ;
  Remanente_Importe :number ;
  VNPP : number = 0;
  Num_Doc_Identificacion_Prov:string = '' ;
  Num_Doc_Identificacion_Adq:string = '' ;
  NombreAdquirente: string = '' ;
  idProveedor: number;
  idAdquirente: number;
  NombreProveedor:string = '' ;
  Scoring_Adquirente:  number = 0;
  Scoring_Proveedor: number = 0;
  Ranking_Adquirente : number = 0;
  Tasa_Mensual:number=0;
  Tipo_Servicio:number;
  Porcentaje_Interes_Adquirente:number;
  idFactor: number;
  }
  
